import { styled } from "@mui/material";

export const Page = styled("div")`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    display: flex;
    align-items: center;
    flex-direction: column;
    box-sizing: border-box;
    background: linear-gradient(
        150deg,
        ${({ theme }) => theme.palette.background.default} 12%,
        #263969
    );
    background-size: 400% 400%;
    animation:
        1s ease forwards container--start,
        container--animation 20s ease infinite;
    position: relative;
    scroll-behavior: smooth;

    button {
        color: white;
    }

    @keyframes container--start {
        0% {
            opacity: 0;
        }
        100% {
            opacity: 1;
        }
    }

    @keyframes container--animation {
        0% {
            background-position: 0% 50%;
        }

        50% {
            background-position: 100% 50%;
        }

        100% {
            background-position: 0% 50%;
        }
    }

    @media only screen and (max-width: 600px) {
        max-width: 100vw;
  
    }

    & .multi-step {
        min-height: fit-content;
        padding: 1rem;
        height: 100%;
        display: flex;
    }

    & .chatStep {
        width: 100%;
        height: 100%;
        max-height: 100%;
        overflow: hidden;
    }
`;

export const LogoContainer = styled("div")`
    width: 220px;
    padding-top: 12px;
    box-sizing: border-box;
    img {
        width: 100%;
    }
`;

export default Page;
